import React from "react";
import { useTranslation } from "react-i18next";

import {
  formatCatalogMoney,
  orderAddonLines,
  orderAddonTotal,
  tableBookingCatalogSnapshot,
} from "../../helpers/clubCatalog";
import "../../pages/clubCatalog/clubCatalog.css";

export function TicketOrderAddonSnapshot({ order }) {
  const { t } = useTranslation();
  const lines = orderAddonLines(order);
  const total = orderAddonTotal(order);
  if (!lines.length && !total) return null;
  return (
    <div className="club-catalog-bill mt-2">
      <div className="fw-semibold mb-1">{t("CATALOG_TICKET_ADDONS")}</div>
      {lines.map((line, i) => (
        <div key={`${line.itemId}-${i}`} className="club-catalog-bill-line">
          {line.name} ×{line.qty} — {formatCatalogMoney(line.lineTotal)}
        </div>
      ))}
      <div className="club-catalog-bill-line fw-semibold">
        {t("CATALOG_ADDON_TOTAL")}: {formatCatalogMoney(total)}
      </div>
    </div>
  );
}

export function TableBookingCatalogSnapshot({ booking }) {
  const { t } = useTranslation();
  const snap = tableBookingCatalogSnapshot(booking);
  const hasCatalog =
    snap.addonLines.length ||
    snap.preorderLines.length ||
    snap.addonTotal ||
    snap.preorderTotal ||
    snap.preorderOverage;
  if (!hasCatalog && !snap.minimumSpend) return null;

  const depositPct =
    snap.minimumSpend > 0
      ? Math.round((snap.depositAmount / snap.minimumSpend) * 100)
      : 50;

  return (
    <div className="club-catalog-bill mt-2">
      {snap.minimumSpend > 0 ? (
        <div className="club-catalog-bill-line">
          {t("CATALOG_TABLE_MIN", {
            table: formatCatalogMoney(snap.minimumSpend, snap.currency),
            pct: depositPct,
            paid: formatCatalogMoney(snap.depositAmount, snap.currency),
          })}
        </div>
      ) : null}
      {snap.preorderLines.map((line, i) => (
        <div key={`p-${line.itemId}-${i}`} className="club-catalog-bill-line">
          {t("CATALOG_PREORDER_LINE", {
            name: line.name,
            amount: formatCatalogMoney(line.lineTotal, snap.currency),
          })}
        </div>
      ))}
      {snap.preorderOverage > 0 ? (
        <div className="club-catalog-bill-line">
          {t("CATALOG_PREORDER_EXTRA_PAID", {
            amount: formatCatalogMoney(snap.preorderOverage, snap.currency),
          })}
        </div>
      ) : null}
      {snap.addonLines.map((line, i) => (
        <div key={`a-${line.itemId}-${i}`} className="club-catalog-bill-line">
          {t("CATALOG_ADDON_BILL_LINE", {
            name: line.name,
            qty: line.qty,
            amount: formatCatalogMoney(line.lineTotal, snap.currency),
          })}
        </div>
      ))}
      {snap.venueDueAmount > 0 || snap.minimumSpend > 0 ? (
        <div className="club-catalog-bill-line fw-semibold">
          {t("CATALOG_STILL_DUE_VENUE", {
            amount: formatCatalogMoney(snap.venueDueAmount, snap.currency),
          })}
        </div>
      ) : null}
    </div>
  );
}

export default TableBookingCatalogSnapshot;
